import type { CartItemForClient, ProductForClient, Variant } from "@/lib/shared/types/interfaces";

/**
 * Calculate total price for cart items plus optional shipping fee.
 */
export function getTotal(
  items: CartItemForClient[],
  conversionRate: number,
  shippingFee = 0,
): number {
  const subTotal = items.reduce((sum: number, item: CartItemForClient) => {
    return sum + getProductPrice(item.product, item.variant, conversionRate) * item.quantity;
  }, 0);

  return Number((subTotal + shippingFee).toFixed(2));
}

/**
 * Get product price for a specific variant
 */
export function getProductPrice(
  product: ProductForClient,
  variant: Variant,
  conversionRate: number,
) {
  const productVariant = product.variants.find((v) => v.variant.id === variant.id);
  if (!productVariant) return 0;
  const price = productVariant.onSalePrice
    ? productVariant.onSalePrice * conversionRate
    : productVariant.price * conversionRate;

  return Number(price.toFixed(2));
}
